export enum DrawerPosition {
  Left = 'Left',
  Right = 'Right',
}
